export default "__VITE_ASSET__Y6J$1Xro__"